import React, { useEffect, useState } from "react";
import { fetchWorkingDays } from "../Api/WorkingDays";
import { updateReconciliationStatus } from "../Api/Reconciliation"; // <-- new API
import { Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";

const ReconciliationCockpit = () => {
  const [workingDays, setWorkingDays] = useState([]);

  useEffect(() => {
    loadWorkingDays();
  }, []);

  const loadWorkingDays = async () => {
    try {
      const response = await fetchWorkingDays();
      // Filter only where reconciliationStatus = 0
      const filtered = (response || []).filter(
        (day) => day.reconciliationStatus === "0"
      );
      setWorkingDays(filtered);
    } catch (error) {
      console.error("Error fetching working days:", error);
    }
  };

  const handleComplete = async (id) => {
    try {
      await updateReconciliationStatus(id);
      toast.success(`Reconciliation status updated for ID: ${id}`);
      loadWorkingDays(); // refresh table
    } catch (error) {
      console.error("Error updating reconciliation status:", error);
      toast.error("Failed to update reconciliation status");
    }
  };

  return (
    <div className="container mt-4">
      <h4>Reconciliation Cockpit</h4>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>WorkingDaysId</th>
            <th>Date</th>
            <th>Day</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {workingDays.length > 0 ? (
            workingDays.map((day, index) => (
              <tr key={day.workingDaysId}>
                <td>{index + 1}</td>
                <td>{day.workingDaysId}</td>
                <td>{day.createdOnDate || "N/A"}</td>
                <td>{day.createdOnTime || "N/A"}</td>
                <td>
                  <Button
                    variant="success"
                    size="sm"
                    onClick={() => handleComplete(day.workingDaysId)}
                  >
                    Complete
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default ReconciliationCockpit;

// import React, { useEffect, useState } from "react";
// import { fetchWorkingDays } from "../Api/WorkingDays";
// import { Table, Button } from "react-bootstrap";
// import { updateReconciliationStatus } from "../Api/Reconciliation";

// const ReconciliationCockpit = () => {
//   const [workingDays, setWorkingDays] = useState([]);

//   useEffect(() => {
//     loadWorkingDays();
//   }, []);

//   const loadWorkingDays = async () => {
//     try {
//       const response = await fetchWorkingDays();
//       console.log(response);
//       // Filter only where reconciliationStatus = 0
//       const filtered = (response || []).filter(
//         (day) => day.reconciliationStatus === "0"
//       );
//       console.log(filtered);
//       setWorkingDays(filtered);
//     } catch (error) {
//       console.error("Error fetching working days:", error);
//     }
//   };

//   const handleComplete = (id) => {
//     console.log("Complete clicked for WorkingDaysId:", id);
//     // You can call your API to update completion status here
//   };

//   return (
//     <div className="container mt-4">
//       <h4>Reconciliation Cockpit</h4>
//       <Table striped bordered hover>
//         <thead>
//           <tr>
//             <th>#</th>
//             <th>WorkingDaysId</th>
//             <th>Date</th>
//             <th>Day</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {workingDays.length > 0 ? (
//             workingDays.map((day, index) => (
//               <tr key={day.WorkingDaysId}>
//                 <td>{index + 1}</td>
//                 <td>{day.workingDaysId}</td>
//                 <td>{day.createdOnDate || "N/A"}</td>
//                 <td>{day.createdOnTime || "N/A"}</td>
//                 <td>
//                   <Button
//                     variant="success"
//                     size="sm"
//                     onClick={() => handleComplete(day.WorkingDaysId)}
//                   >
//                     Complete
//                   </Button>
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="5" className="text-center">
//                 No records found
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </Table>
//     </div>
//   );
// };

// export default ReconciliationCockpit;
